const markets = document.querySelector('.markets-module');

if (markets) {
  const domesticDropdown = markets.querySelector('.domestic-dropdown');
  const exportDropdown = markets.querySelector('.export-dropdown');

  const toggleClass = (dropdown, pathClass, action) => {
    dropdown.classList[action]('is-active');
    markets.querySelectorAll(pathClass).forEach((path) => path.classList[action]('is-active'));
  };

  const handleMouseEnter = (hoveredDropdown, pathClass) => {
    toggleClass(hoveredDropdown, pathClass, 'add');
    const otherDropdown = hoveredDropdown === domesticDropdown ? exportDropdown : domesticDropdown;
    toggleClass(otherDropdown, otherDropdown === domesticDropdown ? '.domestic-path' : '.export-path', 'remove');
  };

  if (domesticDropdown) {
    domesticDropdown.addEventListener('mouseenter', () => handleMouseEnter(domesticDropdown, '.domestic-path'));
  }

  if (exportDropdown) {
    exportDropdown.addEventListener('mouseenter', () => handleMouseEnter(exportDropdown, '.export-path'));
  }
}
